import _ from "lodash";

interface PageInfo {
  pageSize: number;
  currentPage: number;
}

export const usePaginate = () => {
  const pageChange = (
    page: number,
    pageInfo: PageInfo,
    setPageInfo: (data: PageInfo) => void
  ) => {
    setPageInfo({ ...pageInfo, currentPage: page });
  };

  const changeRow = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    pageInfo: PageInfo,
    setPageInfo: (data: PageInfo) => void
  ) => {
    setPageInfo({
      ...pageInfo,
      // eslint-disable-next-line radix
      currentPage: 0,
      pageSize: parseInt(event.target.value, 10)
    });
  };

  const paginate = (items: any[], currentPage: number, pageSize: number) => {
    const startIndex = currentPage * pageSize;
    const array =
      items === undefined
        ? undefined
        : _(items)
            .slice(startIndex)
            .take(pageSize)
            .value();
    return array;
  };

  return {
    changeRow,
    pageChange,
    paginate
  };
};
